<mat-drawer-container class="h-full">
  <mat-drawer class="!w-full" #menu mode="over" position="end">
    @if (templateRef) {
      <ng-container *ngTemplateOutlet="templateRef; context: context" />
    }
  </mat-drawer>

  <ng-content></ng-content>
</mat-drawer-container>
